module.exports = __webpack_public_path__ + "img/21f.e1797e2f.png";